/* Gallery of Scents landing page: size buttons, add to bag, room menu, carousel. */
(function () {
  'use strict';
  if (window.__gosInit) return;
  window.__gosInit = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  /* size buttons: switch price, links and the variant that gets added */
  document.addEventListener('click', function (e) {
    var pill = e.target.closest('[data-gos-size]');
    if (!pill) return;
    var card = pill.closest('[data-gos-card]');
    card.querySelectorAll('[data-gos-size]').forEach(function (b) {
      var on = b === pill;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    /* the store money format wraps prices in <span class=money>, so keep the markup */
    card.querySelectorAll('[data-gos-price]').forEach(function (p) { p.innerHTML = pill.dataset.price; });
    card.querySelectorAll('[data-gos-link]').forEach(function (a) { a.href = pill.dataset.url; });
    card.querySelector('input[name="id"]').value = pill.dataset.variant;
    var add = card.querySelector('.gos-add');
    var soldOut = pill.dataset.available !== 'true';
    add.disabled = soldOut;
    add.querySelector('.gos-long').textContent = soldOut ? add.dataset.soldOut : add.dataset.add;
    add.querySelector('.gos-short').textContent = soldOut ? add.dataset.soldOut : add.dataset.addShort;
  });

  /* add to bag through the theme cart: the drawer rebuilds and opens on ajaxProduct:added */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-gos-form]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('.gos-add');
    var err = form.querySelector('.gos-card__error');
    var id = form.querySelector('input[name="id"]').value;
    btn.disabled = true;
    if (err) err.hidden = true;
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        btn.disabled = false;
        if (!res.ok) {
          if (err) { err.textContent = res.data.description || res.data.message || ''; err.hidden = false; }
          return;
        }
        btn.classList.add('is-added');
        btn.querySelector('.gos-long').textContent = btn.dataset.added;
        btn.querySelector('.gos-short').textContent = btn.dataset.added;
        setTimeout(function () {
          btn.classList.remove('is-added');
          btn.querySelector('.gos-long').textContent = btn.dataset.add;
          btn.querySelector('.gos-short').textContent = btn.dataset.addShort;
        }, 2200);
        var product = res.data.items ? res.data.items[0] : res.data;
        form.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: product, addToCartBtn: btn }, bubbles: true }));
      })
      .catch(function () {
        btn.disabled = false;
        form.submit();
      });
  });

  /* room menu: built from the rooms on the page, highlights the room in view */
  function initNav() {
    var list = document.querySelector('[data-gos-nav]');
    var rooms = Array.prototype.slice.call(document.querySelectorAll('[data-gos-room]'));
    if (!list || !rooms.length) return;
    list.innerHTML = rooms.map(function (r) {
      return '<li><a class="gos-nav__a" href="#' + r.id + '" data-gos-jump="' + r.id + '"><span>' + r.dataset.n + '</span><span>' + r.dataset.name + '</span></a></li>';
    }).join('');

    /* keep the menu under the theme header when the header sticks (it does on phones) */
    var navSec = list.closest('.shopify-section') || list.closest('.gos-nav');
    var header = document.getElementById('SiteHeader');
    var base = parseFloat(getComputedStyle(navSec).top) || 0;
    var headerNow = function () {
      if (!header || !header.classList.contains('site-header--stuck')) return 0;
      return Math.max(0, Math.round(header.getBoundingClientRect().bottom));
    };
    var headerAfterJump = function () {
      return header && window.theme && theme.config && theme.config.stickyHeader ? header.offsetHeight : 0;
    };
    var syncTop = function () {
      var top = Math.max(base, headerNow());
      navSec.style.top = top + 'px';
    };
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { ticking = false; syncTop(); });
    }, { passive: true });
    window.addEventListener('resize', syncTop);
    if (header && 'MutationObserver' in window) {
      new MutationObserver(function () { syncTop(); setTimeout(syncTop, 450); }).observe(header, { attributes: true, attributeFilter: ['class'] });
    }
    syncTop();

    /* room links (menu and the hero button) land just under the header and the menu */
    var jumpTo = function (t) {
      var off = Math.max(base, headerAfterJump()) + navSec.offsetHeight;
      window.scrollTo({ top: t.getBoundingClientRect().top + window.pageYOffset - off, behavior: reduce ? 'auto' : 'smooth' });
    };
    document.addEventListener('click', function (e) {
      var a = e.target.closest('.gos a[href^="#"]');
      if (!a || a.getAttribute('href').length < 2) return;
      var t = document.getElementById(a.getAttribute('href').slice(1));
      if (!t) return;
      e.preventDefault();
      jumpTo(t);
    });
    var rtl = document.documentElement.dir === 'rtl';
    var setActive = function (id) {
      list.querySelectorAll('.gos-nav__a').forEach(function (a) {
        var on = a.dataset.gosJump === id;
        a.classList.toggle('is-on', on);
        if (on) {
          a.setAttribute('aria-current', 'location');
          if (list.scrollWidth > list.clientWidth) {
            var lr = list.getBoundingClientRect();
            var ar = a.getBoundingClientRect();
            list.scrollBy({ left: rtl ? ar.right - lr.right + 20 : ar.left - lr.left - 20, behavior: reduce ? 'auto' : 'smooth' });
          }
        } else {
          a.removeAttribute('aria-current');
        }
      });
    };
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) setActive(en.target.dataset.gosEnd ? '' : en.target.id); });
    }, { rootMargin: '-30% 0px -65% 0px' });
    rooms.forEach(function (r) { io.observe(r); });
    document.querySelectorAll('[data-gos-end]').forEach(function (el) { io.observe(el); });
  }

  /* drag to scroll card rows and the carousel with a mouse (fingers scroll natively) */
  var dEl = null, dMoved = false, dX = 0, dLeft = 0;
  document.addEventListener('pointerdown', function (e) {
    if (e.pointerType !== 'mouse') return;
    var el = e.target.closest('.gos-cards, .gos-mq');
    if (!el || el.scrollWidth <= el.clientWidth + 2) return;
    dEl = el; dMoved = false; dX = e.clientX; dLeft = el.scrollLeft;
  });
  window.addEventListener('pointermove', function (e) {
    if (!dEl) return;
    var dx = e.clientX - dX;
    if (!dMoved && Math.abs(dx) > 6) { dMoved = true; dEl.classList.add('is-dragging'); }
    if (dMoved) dEl.scrollLeft = dLeft - dx;
  });
  window.addEventListener('pointerup', function () {
    if (!dEl) return;
    var el = dEl;
    dEl = null;
    if (!dMoved) return;
    el.classList.remove('is-dragging');
    setTimeout(function () { dMoved = false; }, 0);
  });
  document.addEventListener('click', function (e) { if (dMoved) { e.preventDefault(); e.stopPropagation(); dMoved = false; } }, true);

  /* more-scents carousel: glides left to right, pauses on hover, touch or focus */
  function initCarousel(mq) {
    var speed = 32, pos = 0, paused = false, idle, last = 0, onScreen = true;
    var half = function () { return mq.scrollWidth / 2; };
    var wrap = function () {
      var h = half();
      if (pos <= 1) pos += h;
      else if (pos >= h * 2 - mq.clientWidth - 1) pos -= h;
    };
    requestAnimationFrame(function () { pos = half(); mq.scrollLeft = pos; });
    mq.addEventListener('scroll', function () {
      if (!paused) return;
      pos = mq.scrollLeft;
      var before = pos;
      wrap();
      if (pos !== before) mq.scrollLeft = pos;
    }, { passive: true });
    var hold = function () { paused = true; clearTimeout(idle); };
    var release = function (ms) { clearTimeout(idle); idle = setTimeout(function () { pos = mq.scrollLeft; paused = false; }, ms); };
    mq.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') hold(); });
    mq.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') release(200); });
    mq.addEventListener('pointerdown', function (e) { if (e.pointerType !== 'mouse') hold(); });
    mq.addEventListener('pointerup', function (e) { if (e.pointerType !== 'mouse') release(2500); });
    mq.addEventListener('pointercancel', function () { release(2500); });
    mq.addEventListener('touchend', function () { release(2500); }, { passive: true });
    mq.addEventListener('focusin', hold);
    mq.addEventListener('focusout', function () { release(400); });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { onScreen = es[0].isIntersecting; }).observe(mq);
    }
    var tick = function (t) {
      var dt = last ? Math.min(0.05, (t - last) / 1000) : 0;
      last = t;
      if (!paused && !reduce && onScreen && mq.scrollWidth > mq.clientWidth) {
        pos -= speed * dt;
        wrap();
        mq.scrollLeft = pos;
      }
      requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);
  }

  function init() {
    initNav();
    document.querySelectorAll('[data-gos-mq]').forEach(initCarousel);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
